import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useEffect, useState, useRef } from "react";
import toast from "react-hot-toast";
import { PrimaryButton } from "../../StyledCss/styledbtn";
import AddEmployeePopup from "../AddEmployeePopup";
import Header from "../Header";
import LeftNavBar from "../LeftNavBar";
import SlidingModal from "../SlidingModal/slidingModal";
import PopupModal from "../PopupModal";
import ActiveEmployeeTable from "../ActiveEmployeesTable";
import ReleasedEmployeeTable from "../ReleasedEmployeeTable";
import "./index.css";
import { convertKeysToCamelCase } from "../../util/convertCamelCase";
import { PageHeaderName } from "../../StyledCss/styledComponents";
// import { Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import {
  exportAllEmployees,
  getAllActiveEmployees,
  getAllReleasedEmployees,
  getLeads,
} from "../../api/services/hroneApi";
import formatDate from "../../util/formatdate";
import PageHeader from "../PageHeader";
import UploadEmployeeExcel from "../UploadEmployeesExcel/uploadEmployeeExcel";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";

const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const pageTabs = [
  {
    tabName: "Active",
    tabId: "ACTIVE",
    permissionCode: FEATURE_CODES.EMPLOYEE_ACTIVE_LIST_VIEW,
  },
  {
    tabName: "Released",
    tabId: "RELEASED",
    permissionCode: FEATURE_CODES.EMPLOYEE_RELEASED_LIST_VIEW,
  },
];

const AllEmployees = () => {
  const { hasPermission } = usePermissions();
  const canImport = hasPermission(FEATURE_CODES.EMPLOYEE_IMPORT);
  const canExport = hasPermission(FEATURE_CODES.EMPLOYEE_EXPORT);
  const canCreate = hasPermission(FEATURE_CODES.EMPLOYEE_CREATE);
  const visibleTabs = pageTabs.filter((tab) => hasPermission(tab.permissionCode));
  const [employees, setEmployees] = useState([]);
  const [releasedEmployees, setReleasedEmployees] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.initial);
  const [openPopupExcel, setOpenPopupExcel] = useState(false);
  const [releaseEmployeesApiStatus, setReleaseEmployeesApiStatus] = useState(
    apiStatusConstants.initial
  );
  // const [exportType, setExportType] = useState("All");
  // const [anchorEl, setAnchorEl] = useState(null);



  const [isExportDropdownOpen, setisExportDropdownOpen] = useState(false);
  // const [exportType, setExportType] = useState("all");
  const [leads, setLeads] = useState([]);
  const [activeTab, setActiveTab] = useState(pageTabs[0].tabId);
  // If the selected tab isn't one the user is permitted to see (e.g. tab
  // clicked before permission finished loading, or access was revoked),
  // fall back to the first tab they do have access to.
  const effectiveActiveTab = visibleTabs.some((tab) => tab.tabId === activeTab)
    ? activeTab
    : visibleTabs[0]?.tabId;
  const exportDropdownRef = useRef(null);
  const notifySaved = () => toast.success("Saved Successfully");

  useEffect(() => {
    fetchEmployees();
    fetchLeads();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (effectiveActiveTab === pageTabs[1].tabId) {
      fetchReleasedEmployees();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effectiveActiveTab]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (exportDropdownRef.current && !exportDropdownRef.current.contains(e.target)) {
        setisExportDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCloseExportDropdown = () => {
    setisExportDropdownOpen(false);
  };

  // An employee edit can change employement_status (Active <-> Released), which
  // moves them between tabs — refresh both lists so they show up in the right
  // one instead of only refreshing the tab the edit was made from.
  const refreshAllEmployeeLists = async () => {
    await Promise.all([fetchEmployees(), fetchReleasedEmployees()]);
  };


  const fetchReleasedEmployees = async () => {
    try {
      setReleaseEmployeesApiStatus(apiStatusConstants.inProgress);
      const response = await getAllReleasedEmployees();
      if (response.status === 200) {
        const data = await response.json();
        const camelCaseData = await data.map((employee) =>
          convertKeysToCamelCase(employee)
        );
        const updatedData = camelCaseData.map((eachItem) => {
          const joiningDate = formatDate(eachItem.joiningDate);
          const dateOfBirth = formatDate(eachItem.dateOfBirth);
          return { ...eachItem, joiningDate, dateOfBirth };
        });
        setReleasedEmployees(updatedData);
        setReleaseEmployeesApiStatus(apiStatusConstants.success);
      }
    } catch (error) {
      setApiStatus(apiStatusConstants.failure);
    }
  };

  const toggleIsPopupOpen = () => {
    setIsPopupOpen(false);
  };

  const UpdateEmpAdded = () => {
    notifySaved();
  };

  const fetchEmployees = async () => {
    try {
      setApiStatus(apiStatusConstants.inProgress);
      const response = await getAllActiveEmployees();
      if (response.status === 200) {
        const data = await response.json();
        const camelCaseData = await data.map((employee) =>
          convertKeysToCamelCase(employee)
        );
        const updatedData = camelCaseData.map((eachItem) => {
          const joiningDate = formatDate(eachItem.joiningDate);
          const dateOfBirth = formatDate(eachItem.dateOfBirth);
          return { ...eachItem, joiningDate, dateOfBirth };
        });
        setEmployees(updatedData);
        setApiStatus(apiStatusConstants.success);
      }
    } catch (error) {
      setApiStatus(apiStatusConstants.failure);
    }
  };

  const fetchLeads = async () => {
    try {
      const response = await getLeads();
      if (response.status === 200) {
        const data = await response.json();
        setLeads(data);
      }
    } catch (error) { }
  };

  const handleExportData = async (exportType) => {
    try {
      let response;
  
      if (exportType === "All") {
        response = await exportAllEmployees(exportType);
      } else if (exportType === "Active") {
        response = await exportAllEmployees(exportType);
      } else if (exportType === "Released") {
        response = await exportAllEmployees(exportType);
      }
  
      if (response && response.status === 200) {
        const fileNameFromServer = response.headers["content-disposition"];
        const filename = fileNameFromServer
          ? fileNameFromServer.split("filename=")[1].replace(/"/g, "").trim()
          : `${exportType}_employees.xlsx`;
  
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
  
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = filename;
        downloadLink.click();
        URL.revokeObjectURL(downloadLink.href);
        handleCloseExportDropdown();
      } else {
        console.error("Failed to export data: ", response);
      }
    } catch (error) {
      console.error("Error exporting data:", error);
    }
  };
  


  const onClickAddEmployee = () => {
    setIsPopupOpen(true);
  };

  const onCloseExcelModal = () => {
    setOpenPopupExcel(false);
  };

  const displayActiveTabTable = () => {
    switch (effectiveActiveTab) {
      case "ACTIVE":
        return hasPermission(FEATURE_CODES.EMPLOYEE_ACTIVE_LIST_VIEW) ? (
          <ActiveEmployeeTable
            employeesList={employees}
            apiStatus={apiStatus}
            refreshEmployeesList={refreshAllEmployeeLists}
            leads={leads}
          />
        ) : null;
      case "RELEASED":
        return hasPermission(FEATURE_CODES.EMPLOYEE_RELEASED_LIST_VIEW) ? (
          <ReleasedEmployeeTable
            employeesList={releasedEmployees}
            apiStatus={releaseEmployeesApiStatus}
            refreshEmployeesList={refreshAllEmployeeLists}
            leads={leads}
          />
        ) : null;
      default:
        return null;
    }
  };

  return (
    <>
      <Header />
      <div className="d-flex flex-column  mt-0 all-employees-container">
        <div className="d-flex">
          <LeftNavBar />
          <div className="page-content-wrapper">
            <PageHeader>
              <PageHeaderName>Employees</PageHeaderName>
              <div
                style={{ marginRight: "20px" }}
                className="text-end d-flex align-items-center"
              >
                {canImport && (
                  <PrimaryButton
                    width="150px"
                    style={{ marginLeft: "10px" }}
                    onClick={() => setOpenPopupExcel(!openPopupExcel)}
                  >
                    Import Excel Sheet
                  </PrimaryButton>
                )}
                {canExport && (
                  <div className="dropdown" style={{ position: "relative" }}  ref={exportDropdownRef}>
                    <PrimaryButton
                      className="dropdown-toggle"
                      type="button"
                      onClick={() => {
                        setisExportDropdownOpen(!isExportDropdownOpen);
                      }}
                    >
                      Export Data
                    </PrimaryButton>
                    {isExportDropdownOpen && (
                      <ul className={`dropdown-menu ${isExportDropdownOpen ? 'open' : ''}`}>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => handleExportData("All")}
                          >
                            All Employees
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => handleExportData("Active")}
                          >
                            Active Employees
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => handleExportData("Released")}
                          >
                            Released Employees
                          </button>
                        </li>
                      </ul>
                    )}
                  </div>
                )}




                {canCreate && (
                  <PrimaryButton
                    style={{ marginLeft: "10px" }}
                    type="button"

                    onClick={onClickAddEmployee}
                  >
                    Add Employee
                  </PrimaryButton>
                )}

                {/* {BasicExample()} */}
              </div>
            </PageHeader>

            <div className="table-container">
              <ul style={{ listStyleType: "none" }} className="d-flex">
                {visibleTabs.map((eachItem) => (
                  <li className="me-5" key={eachItem.tabId}>
                    <button
                      className={
                        effectiveActiveTab === eachItem.tabId
                          ? "activeTabButton"
                          : "tabButtons"
                      }
                      // className="tabButtons"
                      onClick={() => setActiveTab(eachItem.tabId)}
                    >
                      {eachItem.tabName}
                    </button>
                  </li>
                ))}
              </ul>

              {displayActiveTabTable()}
            </div>
          </div>
        </div>



        <SlidingModal
          modalName="Add Employee"
          closeBtn={toggleIsPopupOpen}
          isModalOpen={isPopupOpen}
        >
          <AddEmployeePopup
            fetchEmployees={fetchEmployees}
            popupOpen={isPopupOpen}
            toggleIsPopupOpen={toggleIsPopupOpen}
            UpdateEmpAdded={UpdateEmpAdded}
            closeBtn={toggleIsPopupOpen}
            leads={leads}
            fetchLeads={fetchLeads}
          />
        </SlidingModal>

        <PopupModal
          modalName="Upload File"
          closeBtn={onCloseExcelModal}
          showModal={openPopupExcel}
        >
          <UploadEmployeeExcel
            fetchEmployees={fetchEmployees}
            setOpenPopupExcel={setOpenPopupExcel}
          />
        </PopupModal>
      </div>
    </>
  );
};

export default AllEmployees;
